type FormHeaderProps = Readonly<{
  title: string;
  subtitle?: string;
}>;

const FormHeader = ({ title, subtitle }: FormHeaderProps) => {
  return (
    <div className="text-center mb-8">
      <div className="flex justify-between items-start mb-4">
        <h1 className="text-4xl font-bold text-magical-moonlight-dark flex-1">
          {title}
        </h1>
      </div>
      {subtitle ? (
        <p className="text-magical-moonlight-dark text-sm">{subtitle}</p>
      ) : null}
    </div>
  );
};

export default FormHeader;
